import styles from '../styles/Education.module.css';

const EDUCATION = [
  {
    period: '2025',
    title: 'Diploma in Software Engineering',
    place: 'Aptech Computer Education',
    accent: 'cy',
  },
  {
    period: '2024',
    title: 'Intermediate in Computer Science',
    place: null,
    accent: 'pu',
  },
  {
    period: '2022',
    title: 'Matriculation',
    place: null,
    accent: 'cy',
  },
];

export default function Education() {
  return (
    <section id="education" className="section">
      <div className="container">
        <div className="section-head" data-anim>
          <span className="section-index">05</span>
          <span className="section-rule" />
          <h2 className="section-title">Education</h2>
        </div>

        <div className={styles.grid}>
          {EDUCATION.map((entry) => (
            <div key={entry.title} className={`${styles.card} ${styles[entry.accent]}`} data-anim>
              <span className={`${styles.period} ${styles[entry.accent]}`}>{entry.period}</span>
              <h3 className={styles.title}>{entry.title}</h3>
              {entry.place && <div className={styles.place}>{entry.place}</div>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
